import * as React from 'react';

import classnames from 'classnames';

import type {Column} from '../types';

import styles from './table-header-cell.module.css';

type Props = {
    column: Column;
    isResizable: boolean;
    isCompact: boolean;
    hasCellBorders: boolean;
    hasDkCellBorder: boolean;
    customHeaderTitle: string | null | undefined;
    children: React.ReactNode;
};

export function TableHeaderCell(props: Props) {
    const {column, isResizable, isCompact, hasCellBorders, hasDkCellBorder, children} = props;
    const {canSort, getHeaderProps, getSortByToggleProps, toggleSortBy} = column;

    const TH = isResizable ? 'div' : 'th';

    const handleKeyPress = React.useCallback(
        (event: React.KeyboardEvent<any>) => {
            if (toggleSortBy && canSort !== false && (event.key === 'Enter' || event.key === ' ')) {
                event.preventDefault();
                toggleSortBy();
            }
        },
        [canSort, toggleSortBy]
    );

    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    column.hideColumn && column.toggleHidden(true);

    const styleNames = classnames(styles['table-header-cell'], {
        [styles.sortable]: canSort,
        [styles.bordered]: hasCellBorders,
        [styles.compact]: isCompact,
        [styles['grey-cell-text']]: hasDkCellBorder,
        [styles['dk-cell-border']]: hasDkCellBorder && hasCellBorders,
        [styles['left-align-header']]: column.leftAlignHeader,
        [styles['right-align']]: column.rightAlign,
        [styles['center-align']]: column.centerAlign,
    });

    const title = getSortByToggleProps ? getSortByToggleProps().title : undefined;
    const headerTitle = props.customHeaderTitle ? props.customHeaderTitle : title;

    return (
        <TH
            tabIndex={canSort ? 0 : undefined}
            // This includes some sane styling so it should go below our custom style prop
            {...getHeaderProps(getSortByToggleProps ? getSortByToggleProps() : undefined)}
            // Override title from getSortByToggleProps if we pass in a custom one
            title={headerTitle}
            // This isn't built in, so we need to add it ourselves
            onKeyPress={toggleSortBy ? handleKeyPress : undefined}
            className={styleNames}
        >
            {children}
        </TH>
    );
}
